export default __webpack_public_path__ + "static/media/tab_lecturer2_large.6d116caf.png";